// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddArtistFormController from "./add_artist_form_controller"
application.register("add-artist-form", AddArtistFormController)

import AgreementUploadController from "./agreement_upload_controller"
application.register("agreement-upload", AgreementUploadController)

import AlbumFormController from "./album_form_controller"
application.register("album-form", AlbumFormController)

import AlbumPublishController from "./album_publish_controller"
application.register("album-publish", AlbumPublishController)

import AppleArtistSearchController from "./apple_artist_search_controller"
application.register("apple-artist-search", AppleArtistSearchController)

import ApprovalModalController from "./approval_modal_controller"
application.register("approval-modal", ApprovalModalController)

import ArtistFormController from "./artist_form_controller"
application.register("artist-form", ArtistFormController)

import ArtistSearchController from "./artist_search_controller"
application.register("artist-search", ArtistSearchController)

import ChartCheckboxController from "./chart_checkbox_controller"
application.register("chart-checkbox", ChartCheckboxController)

import CollapsibleSectionController from "./collapsible_section_controller"
application.register("collapsible-section", CollapsibleSectionController)

import ContributorRoleSelectController from "./contributor_role_select_controller"
application.register("contributor-role-select", ContributorRoleSelectController)

import ContributorRolesController from "./contributor_roles_controller"
application.register("contributor-roles", ContributorRolesController)

import DateFilterController from "./date_filter_controller"
application.register("date-filter", DateFilterController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DspFilterController from "./dsp_filter_controller"
application.register("dsp-filter", DspFilterController)

import DspRequestHistoryController from "./dsp_request_history_controller"
application.register("dsp-request-history", DspRequestHistoryController)

import DspSelectorController from "./dsp_selector_controller"
application.register("dsp-selector", DspSelectorController)

import DspTakedownController from "./dsp_takedown_controller"
application.register("dsp-takedown", DspTakedownController)

import EditArtistFormController from "./edit_artist_form_controller"
application.register("edit-artist-form", EditArtistFormController)

import EntitySearchController from "./entity_search_controller"
application.register("entity-search", EntitySearchController)

import FeaturingArtistSearchController from "./featuring_artist_search_controller"
application.register("featuring-artist-search", FeaturingArtistSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OrganizationFormController from "./organization_form_controller"
application.register("organization-form", OrganizationFormController)

import OrganizationNotesController from "./organization_notes_controller"
application.register("organization-notes", OrganizationNotesController)

import PerformanceChartController from "./performance_chart_controller"
application.register("performance-chart", PerformanceChartController)

import PeriodFilterController from "./period_filter_controller"
application.register("period-filter", PeriodFilterController)

import PresaveModalController from "./presave_modal_controller"
application.register("presave-modal", PresaveModalController)

import PlaylistRowController from "./playlist_row_controller"
application.register("playlist-row", PlaylistRowController)

import PlaylistStreamsChartController from "./playlist_streams_chart_controller"
application.register("playlist-streams-chart", PlaylistStreamsChartController)

import RejectionModalController from "./rejection_modal_controller"
application.register("rejection-modal", RejectionModalController)

import RoleArtistSearchController from "./role_artist_search_controller"
application.register("role-artist-search", RoleArtistSearchController)

import RoyaltiesEntitySearchController from "./royalties_entity_search_controller"
application.register("royalties-entity-search", RoyaltiesEntitySearchController)

import SavesChartController from "./saves_chart_controller"
application.register("saves-chart", SavesChartController)

import ShortVideoViewsChartController from "./short_video_views_chart_controller"
application.register("short-video-views-chart", ShortVideoViewsChartController)

import SkipsChartController from "./skips_chart_controller"
application.register("skips-chart", SkipsChartController)

import SourceStreamsChartController from "./source_streams_chart_controller"
application.register("source-streams-chart", SourceStreamsChartController)

import SpotifyArtistSearchController from "./spotify_artist_search_controller"
application.register("spotify-artist-search", SpotifyArtistSearchController)

import StoreFilterController from "./store_filter_controller"
application.register("store-filter", StoreFilterController)

import StreamingChartController from "./streaming_chart_controller"
application.register("streaming-chart", StreamingChartController)

import StreamingTabsController from "./streaming_tabs_controller"
application.register("streaming-tabs", StreamingTabsController)

import TerritoryDspFormController from "./territory_dsp_form_controller"
application.register("territory-dsp-form", TerritoryDspFormController)

import TerritoryFilterController from "./territory_filter_controller"
application.register("territory-filter", TerritoryFilterController)

import TerritorySelectorController from "./territory_selector_controller"
application.register("territory-selector", TerritorySelectorController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TrackArtistSearchController from "./track_artist_search_controller"
application.register("track-artist-search", TrackArtistSearchController)

import TrackContributorRolesController from "./track_contributor_roles_controller"
application.register("track-contributor-roles", TrackContributorRolesController)

import TrackFeaturingArtistSearchController from "./track_featuring_artist_search_controller"
application.register("track-featuring-artist-search", TrackFeaturingArtistSearchController)

import TrackPreviewController from "./track_preview_controller"
application.register("track-preview", TrackPreviewController)

import TrackRoleArtistSearchController from "./track_role_artist_search_controller"
application.register("track-role-artist-search", TrackRoleArtistSearchController)

import TrackUploadController from "./track_upload_controller"
application.register("track-upload", TrackUploadController)

import TrendsSnapshotChartController from "./trends_snapshot_chart_controller"
application.register("trends-snapshot-chart", TrendsSnapshotChartController)

import TrendsSnapshotFilterController from "./trends_snapshot_filter_controller"
application.register("trends-snapshot-filter", TrendsSnapshotFilterController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UserOrganizationController from "./user_organization_controller"
application.register("user-organization", UserOrganizationController)

import UserRoleController from "./user_role_controller"
application.register("user-role", UserRoleController)

import YoutubeChartController from "./youtube_chart_controller"
application.register("youtube-chart", YoutubeChartController)
